import { FormInstance } from 'antd';
import { SaffingRequestTemplateQueryResponseType } from 'works/graphql/staffing-request-template';
import { FormValuesType } from './_staffing-request-template-form-types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const findEntityById = (id: string, data: any) =>
  data.find((entity: { id: string }) => entity.id === id);

export const updateTemplateName = (
  form: FormInstance,
  values: FormValuesType,
  data?: SaffingRequestTemplateQueryResponseType
) => {
  const roleText =
    findEntityById(values.roleId, data?.roles)?.abbreviation ?? '';
  const unitNameText =
    findEntityById(values.organizationUnitId, data?.organizationUnits)?.name ??
    '';
  const locationNameText =
    findEntityById(values.organizationBusinessId, data?.organizationBusinesses)
      ?.name ?? '';

  const roleLevelText =
    values.roleLevel && values.roleLevel !== 'not_applicable'
      ? ` ${values.roleLevel}`
      : '';

  const newName = `${unitNameText} - ${roleText}${roleLevelText} - ${locationNameText}`;

  form.setFieldsValue({ name: newName });

  return newName;
};
